import { useCallback } from 'react'
import { useSearchParams } from 'react-router-dom'

const useDetailTab = defaultKey => {
  const [searchParams, setSearchParams] = useSearchParams()
  const activeTab = searchParams.get('tab') || defaultKey

  const setActiveTab = useCallback(
    key => {
      setSearchParams(
        prev => {
          const next = new URLSearchParams(prev)
          next.set('tab', key)
          return next
        },
        { replace: true }
      )
    },
    [setSearchParams]
  )

  return [activeTab, setActiveTab]
}

export default useDetailTab
